export const subtitles = {
    "1": {
        "startTime": 15.97,
        "endTime": 23.69,
        "transcript": "Wanigga-am ukut quyanarqeqapigtellriit naken amaken yaaqvaneng tailuteng qanercillua wanigg' qaneryugnaitellemneng",
        "translation": "Now, I am thankful to these people who came from somewhere far away to have me speak about what I wouldn't have spoken about"
    },
    "2": {
        "startTime": 23.695,
        "endTime": 25.27,
        "transcript": "Qaneryuumillernaamneng.",
        "translation": "When I've wanted to speak about."
    },
    "3": {
        "startTime": 25.27,
        "endTime": 31.81,
        "transcript": "Yaani-llu KYUK-mun iliini tekiartaqama qaneryuumiryaaqaqua.",
        "translation": "And when I sometimes come across KYUK over there, I want to speak."
    },
    "4": {
        "startTime": 31.815,
        "endTime": 38.585,
        "transcript": "Qanqeryuumiryaaqaqua mat'umeng waten tan'gurraat ilii cillangarteqernayukluku.",
        "translation": "I want to say this, in case some one of the boys may come to a realization."
    },
    "5": {
        "startTime": 39.015,
        "endTime": 49.63,
        "transcript": "Kitak' wanigga tau͡gaten tamana qanelqa niilluku niicugniliani tamalkurpeci au͡gaqliitni-llu au͡gani, qang'a-llu maani wani Naparyarmiuni.",
        "translation": "So, hear what I have to say, all of you who are listening, includin in the areas around them, and even here in Hooper Bay."
    },
    "6": {
        "startTime": 49.63,
        "endTime": 56.54,
        "transcript": "Wanigga-tuq maa-i iliit yuut atauciungermi umyugaa qanqerli tamatumeng.",
        "translation": "Now, I hope that some people, eve just one, will say that in his mind."
    },
    "7": {
        "startTime": 56.54,
        "endTime": 62.37,
        "transcript": "Arcaqerluku man'a yuum iqungutkekii man'a aturyuk'ngarci man'a",
        "translation": "Especially with this thing that ends lives that you tend to abuse"
    },
    "8": {
        "startTime": 62.37,
        "endTime": 71.1,
        "transcript": "Alarqutngukan, alarqutngukan man'a taangaq aturyuk'ngarci kituungermi atuyuicaraa.",
        "translation": "It it were a traditional instruction, if alcohol were an instruction, no one would use it no matter who they were."
    },
    "9": {
        "startTime": 71.1,
        "endTime": 74.87,
        "transcript": "Alarquutngunrilan maa-i inerquutaungan aturyugaqaa.",
        "translation": "One tends to abuse it because it's not an instruction, but admonished against."
    },
    "10": {
        "startTime": 74.87,
        "endTime": 80.72,
        "transcript": "Alarquutet tau͡gken aturuyuyuunaki, aturyugluki, aturyugpegnaki.",
        "translation": "However, they don't practice these traditional instructions."
    },
    "11": {
        "startTime": 81.22,
        "endTime": 90.11,
        "transcript": "Alarquutngunrilnguut tau͡gken piluki-wa, ayimumalriatun piluki, ayimumatekluki.",
        "translation": "However, they break themselves over what are not part of traditional instructions."
    },
    "12": {
        "startTime": 90.11,
        "endTime": 94.52,
        "transcript": "Tau͡gaam tau͡ga-i quyanarquq tau͡ga qanqe'rtua wanigga amllenrilengraan.",
        "translation": "But I am thankful for speaking though it wasn't much."
    },
    "13": {
        "startTime": 94.52,
        "endTime": 98.79,
        "transcript": "Quyana cakneq, piuraqici, tau͡ga erneqegciki tau͡gaam.",
        "translation": "Thank you very much, goodbye, but have a good day."
    },
    "14": {
        "startTime": 121.41,
        "endTime": 130.05,
        "transcript": "Atullruunga makuneng imumi callarterpallratni Hooper Bay-rmiut mikelngurrartuumarmeng.",
        "translation": "I used these back when the people of Hooper Bay were afflicted with big sores, including little children."
    },
    "15": {
        "startTime": 130.055,
        "endTime": 132.425,
        "transcript": "Atulqaqa man'a",
        "translation": "I used this"
    },
    "16": {
        "startTime": 132.675,
        "endTime": 139.115,
        "transcript": "Niitetuama qaillun yungcautengqesciigalan all over.",
        "translation": "Because I heard there was no remedy when it's all over."
    },
    "17": {
        "startTime": 139.28,
        "endTime": 147.39,
        "transcript": "Callanret angturriluteng-llu, nullumni-ll' camani ircaquqa maliggluku nutngaryaurrluteng.",
        "translation": "The sores also grew large, and on my buttocks down there, they started pulsing along with my heartbeat."
    },
    "18": {
        "startTime": 147.47,
        "endTime": 153.18,
        "transcript": "Tua-ll' umyugartunglua imkut qagkumiut qanellrat eneqakluku.",
        "translation": "Then I started thinking, remember what the people up north said."
    },
    "19": {
        "startTime": 153.18,
        "endTime": 159.71,
        "transcript": "Imna teq'uq, amaurrlugam teq'urra aqvaluku [?].",
        "translation": "The urine, I went to get my great-grandparent's urine."
    },
    "20": {
        "startTime": 159.71,
        "endTime": 165.33,
        "transcript": "Pia, aqvaluku wii assigcirluku taumeng erurlua.",
        "translation": "I went to get it with a container, and washed myself with that."
    },
    "21": {
        "startTime": 165.335,
        "endTime": 167.675,
        "transcript": "Whoo, very strong.",
        "translation": "Whoo, very strong."
    },
    "22": {
        "startTime": 167.71,
        "endTime": 171.43,
        "transcript": "Kirrelvagluni-ll' qaika, sore.",
        "translation": "The sores on my body burned."
    },
    "23": {
        "startTime": 171.435,
        "endTime": 176.505,
        "transcript": "Sore-arluni maa-i, nulluugka-llu erurlukek cuvayaq au͡g'arluku.",
        "translation": "It was sore here, and I washed the slimy discharge off of my buttocks."
    },
    "24": {
        "startTime": 176.505,
        "endTime": 178.875,
        "transcript": "Cuvayillinilua.",
        "translation": "I was having slimy discharge."
    },
    "25": {
        "startTime": 178.875,
        "endTime": 183.645,
        "transcript": "It's like fish-am cuvayga from the sores.",
        "translation": "It's like fish slime, from the sores."
    },
    "26": {
        "startTime": 183.645,
        "endTime": 193.135,
        "transcript": "Taqngama-llu makut boil-allrenka, boil-allrenka, kuvluku taunga auġg'arluku, allameng rinse-autekluku makut.",
        "translation": "Then when I was done, I dumped that out, and replaced it with another that I boiled, rinsing these sores."
    },
    "27": {
        "startTime": 193.135,
        "endTime": 195.845,
        "transcript": "Rinse-arlua mecuitneng.",
        "translation": "I rinsed with their broth."
    },
    "28": {
        "startTime": 195.845,
        "endTime": 203.695,
        "transcript": "Rinse-arluku taq'ngama nutaan keyianeng nangteqluni qaika, tamalkurmi nutngalriatun ayuqluni",
        "translation": "When I finished rinsing, my body was then in great suffering, like all of it was pulsing"
    },
    "29": {
        "startTime": 203.695,
        "endTime": 209.065,
        "transcript": "Too many sores in my body, mostly in my sit.",
        "translation": "Too many sores in my body, mostly in my sit[ting area]."
    },
    "30": {
        "startTime": 209.455,
        "endTime": 215.755,
        "transcript": "Anturriluteng, nutengvagluteng from my heart, maliggluku.",
        "translation": "They grew large, pulsing from my heart, along with [my heartbeat]."
    },
    "31": {
        "startTime": 216.04,
        "endTime": 220.89,
        "transcript": "And next day assiriqliama assirilua",
        "translation": "And next day, when I finally got better."
    },
    "32": {
        "startTime": 220.89,
        "endTime": 225.19,
        "transcript": "Yuryugumaluku-ll', it's like I smell it for long time.",
        "translation": "I kept breathing it, it's like I smell it for long time."
    },
    "33": {
        "startTime": 225.195,
        "endTime": 229.575,
        "transcript": "Qanemneng, aneryaamneng au͡g'asciigalnganani.",
        "translation": "It's like it coulsn't get out of my mouth, my breath."
    },
    "34": {
        "startTime": 230.21,
        "endTime": 239.42,
        "transcript": "Tau͡ga-ll' unuaquani imkucirlua, tupagtua perriteqalliniluteng, dry up-aqalliniluteng.",
        "translation": "Then the next day, I woke up and they had become clean, had dried up."
    },
    "35": {
        "startTime": 239.55,
        "endTime": 248.18,
        "transcript": "Dry up-arngameng-llu maliggluku taun kengelkelluku assiriinarluteng, kiitau͡gan' assiriut.",
        "translation": "Then when they dried up, following that time, they improved until eventually they got better."
    },
    "36": {
        "startTime": 248.84,
        "endTime": 253.83,
        "transcript": "Kinguakun-ll' tayim' pinqigtevkenii tau͡gaten.",
        "translation": "And after that, I never went through that again."
    },
    "37": {
        "startTime": 279.65,
        "endTime": 286.84,
        "transcript": "Waniwa mat'um nalliini uksumi",
        "translation": "These days, in the winter"
    },
    "38": {
        "startTime": 286.84,
        "endTime": 293.64,
        "transcript": "Ukut waniwa ellalliurcuutet, qerrullik ellalliurcuun",
        "translation": "These pieces of rain gear, rain pants"
    },
    "39": {
        "startTime": 293.915,
        "endTime": 302.655,
        "transcript": "Taukut tua-i uksumi waten cataicunailnguut ayagaluni.",
        "translation": "Those are things that should not be missing when one travels in the winter like this."
    },
    "40": {
        "startTime": 307.42,
        "endTime": 314.98,
        "transcript": "Tua-i uum temem waniw' assirluni",
        "translation": "In order for this body to stay well"
    },
    "41": {
        "startTime": 316.152,
        "endTime": 328.937,
        "transcript": "Tuaggun cali maani nunam qaingani pekeskumta yuilqumi, ukut tua-i waniw' ellalliurcuutet, yaa, cataicunailnguut",
        "translation": "Through that, when we traveled on the land here in the wilderness, these pieces of rain gear, yes, should not be missing"
    },
    "42": {
        "startTime": 328.944,
        "endTime": 334.658,
        "transcript": "Uum temem assirluni pillerkaa.",
        "translation": "So that this body will stay well [and safe]."
    },
    "43": {
        "startTime": 335.336,
        "endTime": 346.279,
        "transcript": "Tua-i-llu pitsaqevkenani cali ellalliurcuutaunani yuilqumi arenqiallugeskuni",
        "translation": "Then, should one also be withouta rain gear when they come to misfortune in the wilderness"
    },
    "44": {
        "startTime": 347.911,
        "endTime": 355.854,
        "transcript": "Ellaqerruskani, tua-i wangkuta alerqutullruitkut",
        "translation": "If the weather turns on them, they would instruct us"
    },
    "45": {
        "startTime": 356.364,
        "endTime": 367.963,
        "transcript": "Ayuquciiruskuta-gguq, ayuquciireskumta ayagiinarpek'nata arulaiqilta",
        "translation": "They said that if we get lost, we shouldn't keep going but stop"
    },
    "46": {
        "startTime": 368.423,
        "endTime": 371.938,
        "transcript": "Wall'u pirtunguskakut.",
        "translation": "Or if a blizzard starts on us."
    },
    "47": {
        "startTime": 373.454,
        "endTime": 379.611,
        "transcript": "Nutaan-gguq waten tua-i nangrramta pikumta",
        "translation": "They said that if we are standing as we are now"
    },
    "48": {
        "startTime": 381.054,
        "endTime": 392.682,
        "transcript": "Camek-wa tua-i piinata ayagakumta, aklumek kangcirarrarmek-llu piinata",
        "translation": "If we have nothing as we travel, and don't have a tarpaulin"
    },
    "49": {
        "startTime": 392.694,
        "endTime": 395.88,
        "transcript": "Waten alerqutullruitkut:",
        "translation": "They used to instruct us like this:"
    },
    "50": {
        "startTime": 395.893,
        "endTime": 406.678,
        "transcript": "Tua-i-gguq arenqiallugeskumta pirtunguskakut, waten qanikcaq elagluku.",
        "translation": "They said that if we get into misfortune and a blizzard sets on us, we should dig into the snow like this."
    },
    "51": {
        "startTime": 411.019,
        "endTime": 417.947,
        "transcript": "Tuavet tua-i itqilta, camek tau͡gaam cali tegumiarrarluta.",
        "translation": "They told us to go in, but to have something in hand."
    },
    "52": {
        "startTime": 417.97,
        "endTime": 424.928,
        "transcript": "Una-gguq waniw' ayaruq uum temem cali anirtuumatkaqaa.",
        "translation": "They said that this walking staff will also save this body."
    },
    "53": {
        "startTime": 424.938,
        "endTime": 434.881,
        "transcript": "Wall'u uksumi ayaruilkuni, ca-w' tua-i naparraq tegumiaqluku ayagakuni.",
        "translation": "Or if he has not staff in the winter, he should hold a little tree as he travels."
    },
    "54": {
        "startTime": 434.944,
        "endTime": 444.559,
        "transcript": "Tua-i-llu pirtunguskani ayuquciiruskuni elaulluni qanikcautelluni.",
        "translation": "Then if a blizzard sets and he's lost, he should dive and have the snow build."
    },
    "55": {
        "startTime": 444.574,
        "endTime": 453.717,
        "transcript": "Tau͡gaam cali imkunun, kanarviknernek iciw' aptukput ilutulriit?",
        "translation": "But those things, you know how we call those deep hollows [?kanarvikneret]?"
    },
    "56": {
        "startTime": 453.735,
        "endTime": 459.892,
        "transcript": "Pirciqan pagna qertuluni, tua-i-llu una ilutuluni",
        "translation": "If there's a blizzard, the [the snowbank] up there is tall, and this is deeply hollowed"
    },
    "57": {
        "startTime": 459.901,
        "endTime": 466.144,
        "transcript": "Tamaavet-gguq qanikcaucetenrilkilta.",
        "translation": "They said we shouldn't let the snow cover us there."
    },
    "58": {
        "startTime": 466.169,
        "endTime": 474.84,
        "transcript": "Imumun-gguq tau͡gaam waten qerkilngurmun elagluku tauna.",
        "translation": "Instead, they said to dig a snowbank that isn't tall."
    },
    "59": {
        "startTime": 474.857,
        "endTime": 487.428,
        "transcript": "Iqtumta tuavet tua-i engelqayaguskumta, una imna itlerput patuqerluku qanikcarmek.",
        "translation": "When we go in as soon as we fit in there, we should cover the entrace here with snow."
    },
    "60": {
        "startTime": 487.433,
        "endTime": 491.619,
        "transcript": "Tau͡gaam-gguq engelqiutevkenata.",
        "translation": "But they said not to have it encase us."
    },
    "61": {
        "startTime": 491.633,
        "endTime": 500.475,
        "transcript": "Waten elliuraqluku qanikcaq, una-llu naparrluku pagaavet, ukilluku pikna.",
        "translation": "Do this to the know, and set this [staff] upright up there, piercing the ceiling."
    },
    "62": {
        "startTime": 501.792,
        "endTime": 510.35,
        "transcript": "Tua-i qanikcauskakut pikna tua͡gaam waten elliuqaqluku.",
        "translation": "If the snow covers us, we should do this with [the hole] up there."
    },
    "63": {
        "startTime": 510.914,
        "endTime": 517.885,
        "transcript": "Umcikuni-gguq qanikcaam aciani epciquq yuk.",
        "translation": "They said that if it's airtight under the snow, the person will suffocate."
    },
    "64": {
        "startTime": 547.377,
        "endTime": 560.706,
        "transcript": "Tau͡ga maa-i alarquutet-wa tamakut tan'gurraullemteńi elpengelqa tamana waten civugngaluni pinarqenrituq.",
        "translation": "These traditional instructions when I became aware when we were boys, one should not ignore the like this."
    },
    "65": {
        "startTime": 560.721,
        "endTime": 572.85,
        "transcript": "Iliini anrutamineng-llu makuneng lavkaaneng piitellratni, unangkengameggneng tau͡gaam maaken piaqata",
        "translation": "Sometimes their stomachs, when they didn't have these stores, when they only had what they gathered from here"
    },
    "66": {
        "startTime": 572.858,
        "endTime": 580.03,
        "transcript": "Iliini-llu anrutaq-wa kanavirutekluku.",
        "translation": "Sometimes, they would discouraged from their stomachs."
    },
    "67": {
        "startTime": 580.054,
        "endTime": 590.226,
        "transcript": "Cali caitellemteńeng, aturaitellemteńeng, tamakuneng kanavirucirluta pitullruukut civugngavkenata.",
        "translation": "We would also be discouraged from having nothing, no clothes, and did not ignore [traditional wisdom]."
    },
    "68": {
        "startTime": 590.53,
        "endTime": 601.645,
        "transcript": "Tamakut yullret angullrenka unangkengameggneng tau͡gaam maaken cuverkengameggneng, lavkaaneng pivkenateng.",
        "translation": "Those people I was born in time to see back then only gathered [?through hard work] from here, not from stores."
    },
    "69": {
        "startTime": 601.663,
        "endTime": 607.006,
        "transcript": "Tamakuneng tau͡ga neq'lirluteng pitullruut.",
        "translation": "Those were their food sources."
    },
    "70": {
        "startTime": 607.022,
        "endTime": 612.851,
        "transcript": "Cali temait kayullruuq, nallunritanka.",
        "translation": "I also know that their bodies were strong."
    },
    "71": {
        "startTime": 612.865,
        "endTime": 622.594,
        "transcript": "Makut ping'e'rmeng ak'allauluteng tang'nge'rmeng pillret waten tau͡ga kayungluteng pillruluteng.",
        "translation": "Though these people looked old, they would be strong like this."
    },
    "72": {
        "startTime": 622.624,
        "endTime": 629.482,
        "transcript": "Cali tamakut elpenga'artellrenka tangellrenka yuut assillruut.",
        "translation": "Also, those people I saw in my earliest memories were good."
    },
    "73": {
        "startTime": 629.493,
        "endTime": 634.536,
        "transcript": "Naklegtarluteng, qanruyutai cali.",
        "translation": "They were compassionate, and [followed] traditional wisdom."
    },
    "74": {
        "startTime": 634.556,
        "endTime": 638.042,
        "transcript": "Assirluteng tau͡ga tau͡gaten ayuqluteng.",
        "translation": "They were also good like that."
    },
    "75": {
        "startTime": 638.052,
        "endTime": 644.324,
        "transcript": "Qanruyutai tau͡ga tau͡gaten ayuqluteng pillruluteng.",
        "translation": "They also followed their traditional wisdom."
    },
    "76": {
        "startTime": 645.314,
        "endTime": 656.914,
        "transcript": "Qanruquratulqaatnga tamakut pistekama, uyviitesqevkenii waten pisqevkenii.",
        "translation": "The people who were my instructs always told me not to act mindlessly like this."
    },
    "77": {
        "startTime": 656.927,
        "endTime": 664.484,
        "transcript": "Akuyrartellriit-llu makut ilagarluki pitullruunga.",
        "translation": "I also joind those who were being mischievous."
    },
    "78": {
        "startTime": 664.489,
        "endTime": 675.689,
        "transcript": "Tau͡ga-gguq tamaa-i tamakut-wa akuyrarulluteng, akuyrarrluteng pilriit cameng-wa unangnarqevkenateng.",
        "translation": "They said that those who are being mischievous together, acting mischievous, do not let us gain anything."
    },
    "79": {
        "startTime": 675.706,
        "endTime": 686.477,
        "transcript": "Tau͡gaam una umyugartuareluni, qaillun-wa picirkani tamana-wa piureluku pilria-wa",
        "translation": "But they said that one who is always sensible, who constantly does what they should do"
    },
    "80": {
        "startTime": 686.494,
        "endTime": 692.279,
        "transcript": "Elluarrluni, assirluni-wa eglertetullruuq.",
        "translation": "Would go [through life] correctly, and well."
    },
    "81": {
        "startTime": 716.836,
        "endTime": 723.979,
        "transcript": "Una-gguq wanigga wangkut yungcautvut rosewort-aq.",
        "translation": "This is what they call our medicine, rosewort."
    },
    "82": {
        "startTime": 725.764,
        "endTime": 728.764,
        "transcript": "Yugtun atengqerrluni caqlaq.",
        "translation": "It's Yup'ik name is caqlaq."
    },
    "83": {
        "startTime": 728.783,
        "endTime": 731.626,
        "transcript": "Igyariqaqamta yungcautvut.",
        "translation": "It's our medicine for sore throats."
    },
    "84": {
        "startTime": 731.633,
        "endTime": 734.575,
        "transcript": "Wanigg' kepqataqa, kepluku.",
        "translation": "I'm going to cut it now."
    },
    "85": {
        "startTime": 735.688,
        "endTime": 737.516,
        "transcript": "Aling.",
        "translation": "Oh my."
    },
    "86": {
        "startTime": 738.276,
        "endTime": 743.248,
        "transcript": "Kepluku wanigg, iliineng kepluku tamualua.",
        "translation": "I'm going to cut part of it and chew it."
    },
    "87": {
        "startTime": 743.271,
        "endTime": 748.842,
        "transcript": "Yungcautellrit maa-i makut akurtellratni yungcautaitellratni.",
        "translation": "This was their medicing long ago when they didn't have [Western] medicine."
    },
    "88": {
        "startTime": 758.843,
        "endTime": 767.943,
        "transcript": "Maa-i makut igyariq'qapiarellemni-ll' iciu͡gaq cayaaqlua yungcartet kapureyaaqlua taqlua clinic-aryaaqlua.",
        "translation": "With these, when I had a bad sore throat recently, doctors did things to me, gave me all kinds of shots in the clinic."
    },
    "89": {
        "startTime": 767.959,
        "endTime": 774.317,
        "transcript": "Kapuryaaqlua tau͡ga. Makut-am teguqerluki nerlua.",
        "translation": "They gave me many shots. I took this and ate some."
    },
    "90": {
        "startTime": 774.337,
        "endTime": 779.652,
        "transcript": "Tau͡ga-ll' nerlua maaten unuaquani piaqa igyariqelqa tayim' tamallinilria.",
        "translation": "Then I ate and woke up the next day to find my sore throat was gone."
    },
    "91": {
        "startTime": 779.662,
        "endTime": 783.691,
        "transcript": "Akaurtellrani tau͡gaam makut maa-i yungcautellrit.",
        "translation": "But this was their medicine long ago."
    },
    "92": {
        "startTime": 783.707,
        "endTime": 787.449,
        "transcript": "Au͡gna pitangqertuq, pau͡gna-llu.",
        "translation": "There's some over there, and inland."
    },
    "93": {
        "startTime": 787.96,
        "endTime": 792.174,
        "transcript": "Nulagaqameng tau͡ga amlletuut, amlleq.",
        "translation": "When they grow, there are a lot of them."
    },
    "94": {
        "startTime": 792.192,
        "endTime": 798.449,
        "transcript": "Maa-i-ll' quyurciluteng, I got one whole jar-aq imirluku.",
        "translation": "And altogether now, I got one whole full jar."
    },
    "95": {
        "startTime": 798.644,
        "endTime": 803.387,
        "transcript": "Qessakengraaki-llu alikengraaki panima makucit",
        "translation": "And though my daughter rejects and fears these"
    },
    "96": {
        "startTime": 803.4,
        "endTime": 816.514,
        "transcript": "\"Usviipaa-ll' elpeni. Grandma-rpet-ggem pitulqaaten igyariqaqavet makuneng neresqelluten. Tamualiqu'urluten-ll' nerqeńauraaten callarciaqan.\"",
        "translation": "\"You're so foolish. Wouldn't your grandma tell you to eat these when you have a sore throat? And she'd chew them and feed them to you when you had sores.\""
    },
    "97": {
        "startTime": 816.519,
        "endTime": 821.191,
        "transcript": "Akaurtellrani tau͡gaten tua-i pitullruukut.",
        "translation": "We used to do that long ago."
    },
    "98": {
        "startTime": 845.475,
        "endTime": 850.375,
        "transcript": "Pakissaakuma-gguq utngungsaraat neqaitneng pakissaakuma",
        "translation": "She said that if I look for vole caches with mare's-tail tubers"
    },
    "99": {
        "startTime": 850.388,
        "endTime": 857.945,
        "transcript": "Pakikengkuma, pakikengkuma quarruugneng, needlefish",
        "translation": "If I find a vole cache with sticklebacks, needlefish"
    },
    "100": {
        "startTime": 858.136,
        "endTime": 863.593,
        "transcript": "Taukut-gguq ilaiqaqilaki, ataucimeng tau͡gaam, just one.",
        "translation": "She said I should eat one, but just one."
    },
    "101": {
        "startTime": 863.606,
        "endTime": 869.406,
        "transcript": "Tua-i-ll' pakissaag[gviirlua] pakikengua ik'ikik' pekluteng.",
        "translation": "Then as I was looking for vole caches, I found one with so many moving."
    },
    "102": {
        "startTime": 869.421,
        "endTime": 876.907,
        "transcript": "Tua-ll' umyugartuqaqilii, \"Ala, Aanama-ggem pakikengkuma quarruugneng ataucimeng neresqelqaanga.\"",
        "translation": "Then I thought, \"Oh my, didn't my Aana tell me that if I found a cache with sticklacks that I should eat one?\""
    },
    "103": {
        "startTime": 876.926,
        "endTime": 880.083,
        "transcript": "Tau͡ga nerqaqilii ataucirmeng.",
        "translation": "I ate one."
    },
    "104": {
        "startTime": 880.094,
        "endTime": 885.894,
        "transcript": "Ayakataraqama tau͡ga cailkamun-llu alarqurnauraanga tau͡gaten.",
        "translation": "When I would go to the wilderness, that's how she would instruct me."
    },
    "105": {
        "startTime": 885.903,
        "endTime": 895.932,
        "transcript": "Tuamtell' caqerlunung, caqerlua, aipaqa taunga pakikenguq, Ignatius Black-aq-llu wangkuk friend-aqellruamegnung miktellmegni.",
        "translation": "Then one day, my companion found a vole cache, since Ignatius Black and I were friends when we were small."
    },
    "106": {
        "startTime": 895.947,
        "endTime": 900.075,
        "transcript": "Pakikengami im' qayagpagaanga, \"Ala, cat makut?“",
        "translation": "When he found a cache, he called to me, \"Oh my, what are these?\""
    },
    "107": {
        "startTime": 900.095,
        "endTime": 906.652,
        "transcript": "Ala maaten ullagluku piaqa, imut ciissit.",
        "translation": "Oh my, I went to him and found those bugs."
    },
    "108": {
        "startTime": 910.432,
        "endTime": 914.461,
        "transcript": "Cat imkut ciutmun itetulit meriit.",
        "translation": "Those things that go into ears, [?meriit]."
    },
    "109": {
        "startTime": 914.474,
        "endTime": 919.445,
        "transcript": "Ala tamakut pekluteng. Qaill'-kiq nernaqsartat?",
        "translation": "Oh my, they were moving. How could we eat them?"
    },
    "110": {
        "startTime": 919.457,
        "endTime": 926.457,
        "transcript": "[?]nguaryaaqvimneng tau͡ga niiskilaku tauna aipaqa, \"Quurruugunritut. Wii nerngaitua tamakuneng.\"",
        "translation": "After I [?], I heard my companion, \"They're not sticklebacks. I won't eat those.\""
    },
    "111": {
        "startTime": 926.471,
        "endTime": 928.985,
        "transcript": "Ayaglunung-llu.",
        "translation": "And we traveled on."
    },
    "112": {
        "startTime": 928.988,
        "endTime": 937.803,
        "transcript": "Cunagg' tekicamegnung-am Aanama, taum great-grandma-ma apqangaqekiinga tamakuneng qaillun pillem[neng].",
        "translation": "When we arrived home, my Aana [Mother], my great-grandma ended up asking me what I did with those."
    },
    "113": {
        "startTime": 937.819,
        "endTime": 942.048,
        "transcript": "\"Tau͡ga-llu-q' nerellrun[rituten?\" \"Nerqallruunga.\" Quyaklua-llu.",
        "translation": "\"So did you eat?\" \"I ate.\" And he was thankful for me."
    },
    "114": {
        "startTime": 942.061,
        "endTime": 944.075,
        "transcript": "Ala caullruat?",
        "translation": "Oh my, what were they?"
    },
    "115": {
        "startTime": 944.091,
        "endTime": 950.449,
        "transcript": "Maybe Aanama calqeńgatai. Calqeńgataanga.",
        "translation": "Maybe they were my Aana's work. I think she bewitched me."
    },
    "116": {
        "startTime": 975.916,
        "endTime": 987.43,
        "transcript": "Cali imkunun qetunrayagaqa piipiqa, last baby-qa keggluku, anngaan keggluku.",
        "translation": "My baby son, my last baby, was bitten, bitten by his older brother."
    },
    "117": {
        "startTime": 987.456,
        "endTime": 992.413,
        "transcript": "Ukuakun tau͡g keggsaaqluku, ukuakun keggsaaqluku malrugneng.",
        "translation": "He bit him here, bit him here twice."
    },
    "118": {
        "startTime": 992.423,
        "endTime": 1007.438,
        "transcript": "Maaten alaqaqa makucimeng tegulluni taukuk qamavet keggutain enait makucineng kevirturaqai.",
        "translation": "I found him and found that he took this and stuffed the two bite punctures with these."
    },
    "119": {
        "startTime": 1007.456,
        "endTime": 1010.656,
        "transcript": "Kevirturluki nemerluku-llu.",
        "translation": "He stuffed and bound them."
    },
    "120": {
        "startTime": 1010.666,
        "endTime": 1021.138,
        "transcript": "Maaten unuaquan manii, ala mamqertelliuq tayim'. Puverpalleq-ll' imna red-aulleq tayima.",
        "translation": "He showed them the next morning, and oh my, they were healed. What was swollen and red was gone."
    },
    "121": {
        "startTime": 1021.151,
        "endTime": 1027.394,
        "transcript": "Tau͡gani clinic-iurtet-ll' iillakelqaat, [?]-aq.",
        "translation": "At that time, the health aides were also amazed at that, the [?]."
    },
    "122": {
        "startTime": 1027.401,
        "endTime": 1029.601,
        "transcript": "Kapurarkauyaaqluni.",
        "translation": "He was supposed to get shots."
    },
    "123": {
        "startTime": 1029.62,
        "endTime": 1035.72,
        "transcript": "Ayagyunrilami-am amavet, atakuani wanigg' unuaquani ayagciqluni",
        "translation": "Since he didn't want to travel there, as he was supposed to go in the evening the next day"
    },
    "124": {
        "startTime": 1035.736,
        "endTime": 1039.936,
        "transcript": "Makucineng kevirturallii nallumteńi.",
        "translation": "He stuffed them with these without our knowledge."
    },
    "125": {
        "startTime": 1039.955,
        "endTime": 1046.212,
        "transcript": "Tayima-ll'mamlliniluteng. Caniluku-ll' tayim' makuni piniyuunaku.",
        "translation": "They healed. And he never said there was any problem with this part."
    },
    "126": {
        "startTime": 1046.219,
        "endTime": 1050.062,
        "transcript": "Makuneng kevirturluku.",
        "translation": "He stuffed them with these."
    },
    "127": {
        "startTime": 1077.142,
        "endTime": 1088.185,
        "transcript": "Tau͡ga-llu wii angayuqaagka-am maligtaqungnaqlukek miktellemni yullrulrianga.",
        "translation": "And so, I lived by trying to obey my parents when I was small."
    },
    "128": {
        "startTime": 1088.484,
        "endTime": 1094.213,
        "transcript": "Aatama-llu qaneryaraa umyugamneng tamayuunani au͡gna.",
        "translation": "And my father's traditional wisdom back then never leaves my mind."
    },
    "129": {
        "startTime": 1094.703,
        "endTime": 1104.874,
        "transcript": "Qanrullua, assirpegnii cuukuma nunanun ayakuma nunakenrilkemnun",
        "translation": "He told me that if I do not live well and go to other villages that are not my own"
    },
    "130": {
        "startTime": 1105.088,
        "endTime": 1113.288,
        "transcript": "Atqa niiskunegteggu tau͡gaggun inerciiganii wii callemkun nallungaitniluku.",
        "translation": "He said that when they hear my name, they will know me by my misbehavior."
    },
    "131": {
        "startTime": 1113.309,
        "endTime": 1122.938,
        "transcript": "Kaynguyugcetaarlua qanrutellrukiinga. Wanigga-llu umyugaqenriyuunaku tamana wii alerquutekellra.",
        "translation": "He told me so that I'd be ashamed [of being like that. And now, I always remember his instruction."
    },
    "132": {
        "startTime": 1125.058,
        "endTime": 1133.143,
        "transcript": "Aanama cali ilanka naklekureluki pisqelluki qanrut'tullrulua.",
        "translation": "My mother also told me to always be compassionate to those around me."
    },
    "133": {
        "startTime": 1133.546,
        "endTime": 1138.875,
        "transcript": "Elpeci angayuqaaci ayagyugarni niiyngaarkaugaci.",
        "translation": "You young people must obey your parents."
    },
    "134": {
        "startTime": 1138.895,
        "endTime": 1143.623,
        "transcript": "Miktellerpecini-llu qanruyutelci unimeqaqsaunaki.",
        "translation": "And never forget the traditional wisdom you were told when you were small."
    },
    "135": {
        "startTime": 1143.923,
        "endTime": 1152.109,
        "transcript": "Arcaqerluci enem iluani angayuqaarci takaqerkaugarci.",
        "translation": "It's especially important for you to respect your parent in the home."
    },
    "136": {
        "startTime": 1152.125,
        "endTime": 1157.554,
        "transcript": "Qancurlagaksaunaci wall'u-qaa cat pileryagaksaunaki.",
        "translation": "Do not speak harshly or do things harshly"
    },
    "137": {
        "startTime": 1157.561,
        "endTime": 1162.061,
        "transcript": "Angayuqaarpeci umyugait pekcetenrilkurrluki.",
        "translation": "Try not to [negatively] affect your parents' mental state."
    },
    "138": {
        "startTime": 1162.275,
        "endTime": 1171.489,
        "transcript": "Angayuqaaci angayuqaarulriani iluteqaqut nalluvcini qaillun picurlagaluci piaqavci.",
        "translation": "Your parents, those who are parents are heartbroken without your knowledge when you misbehave."
    },
    "139": {
        "startTime": 1196.466,
        "endTime": 1202.224,
        "transcript": "Tau͡ga-llu ukuk angayuqaagma waten qanrut'tulqaagnenga:",
        "translation": "Then, my parents used to tell me this:"
    },
    "140": {
        "startTime": 1203.216,
        "endTime": 1214.273,
        "transcript": "Cameng mat'umeng puyumeng-llu wall'u-qaa naryalngunarqelriameng enemni pikuma",
        "translation": "If I deal with something, even smoke or something that I get tired of smelling"
    },
    "141": {
        "startTime": 1214.286,
        "endTime": 1220.786,
        "transcript": "Miktellemteńeng ayagluta uqumeng qengaput iluitgun mingutulqai",
        "translation": "Starting from when we were smell, they'd apply seal oil inside our noses"
    },
    "142": {
        "startTime": 1220.805,
        "endTime": 1229.076,
        "transcript": "Nasqulngunayukluta, tepmun-llu tamatumun assiirutnayukluta.",
        "translation": "Because we might get headaches, and we might be negatively affected by that odor."
    },
    "143": {
        "startTime": 1229.094,
        "endTime": 1236.822,
        "transcript": "Ayuqluku maa-i kaassaat, puyuunrilnge'rmeng kaassat naryalngunarqelriit.",
        "translation": "The same way with gas, we get tired of smelling gas even though they're not smoke."
    },
    "144": {
        "startTime": 1236.874,
        "endTime": 1246.874,
        "transcript": "Qengaput mingugarkaugaput iluitgun, cali mikelnguut qengait mingugluki.",
        "translation": "We must apply [seal oil] inside our noses, and also apply it to children's noses."
    },
    "145": {
        "startTime": 1247.405,
        "endTime": 1253.348,
        "transcript": "Cali-llu cailkamun ayakuvci nangteqkuvci",
        "translation": "Also, if you go to the wilderness and get sick"
    },
    "146": {
        "startTime": 1253.357,
        "endTime": 1259.843,
        "transcript": "Cungcautekaituci cailkami uitakuvci arenqiallugeskuvci.",
        "translation": "You have no medicine if you're in the wilderness and get into misfortune."
    },
    "147": {
        "startTime": 1261.477,
        "endTime": 1269.091,
        "transcript": "Uquutengqerquvci cakneq quyerluci, qamna assiilkan igyararci kapqelqilluni",
        "translation": "If you have seal oil when you have a bad cold, if your throat inside is bad and has prickling pain"
    },
    "148": {
        "startTime": 1269.109,
        "endTime": 1274.509,
        "transcript": "Uqu'urmeng aygurarturarkauguci. Aanama pitulqaakut wangkuta.",
        "translation": "You must [?take] seal oil. My mother used to say that to us."
    },
    "149": {
        "startTime": 1275.049,
        "endTime": 1280.634,
        "transcript": "Cali-llu quyeryuarassiyaakumta meq'ercilluta",
        "translation": "Also, they would have us drink [seal oil] if we had a persistent cough"
    },
    "150": {
        "startTime": 1280.654,
        "endTime": 1288.011,
        "transcript": "Aspirin-arkaitellemteńi tau͡gaten miktellemteńi pitulqaakut clinic-angqeyuitellruamta.",
        "translation": "When we had no aspirin, they would have us do that when we were small since we didn't have clinics."
    },
    "151": {
        "startTime": 1314.488,
        "endTime": 1322.688,
        "transcript": "Man'a taangaq elpecinun assinritapiareyaaquq atungnaqellra.",
        "translation": "It's very bad for you to abuse alcohol."
    },
    "152": {
        "startTime": 1322.7,
        "endTime": 1331.385,
        "transcript": "Tau͡gaam taangaq man'a trouble-aamun tau͡gaam pinaqluni.",
        "translation": "Instead, alcohol only leads to trouble."
    },
    "153": {
        "startTime": 1331.398,
        "endTime": 1340.698,
        "transcript": "Cali yuk taangarpakarluni iqlutmun piarkaqenrilkeńi tekilluku ellmineng picurlatuuq.",
        "translation": "Also, when a person abuses alcohol too much, they come upon things they're not supposed to and bring misfortune upon themselves."
    },
    "154": {
        "startTime": 1340.713,
        "endTime": 1344.699,
        "transcript": "Cali man'a meluk aipaa...",
        "translation": "Also, this other one, smoking..."
    },
    "155": {
        "startTime": 1344.938,
        "endTime": 1347.338,
        "transcript": "Patuu.",
        "translation": "Close it."
    },
    "156": {
        "startTime": 1347.354,
        "endTime": 1358.782,
        "transcript": "Aipaa tamana meluk man'a umyugamun tau͡gaam ayatulria, man'a-llu tema tapulluku.",
        "translation": "The other one, smoking only goes to the mind, and along with this body."
    },
    "157": {
        "startTime": 1358.797,
        "endTime": 1363.168,
        "transcript": "Wii atuyuicaaqaqa qaillun ayuqellra.",
        "translation": "I don't experience what it's like."
    },
    "158": {
        "startTime": 1363.174,
        "endTime": 1373.259,
        "transcript": "Tau͡gaam niitetuama wanigga tamatumeng melugmeng ayuqucianeng, umyugaq tau͡gaam navgutuniluku.",
        "translation": "But I hear about what that smoking is like, that it destroys the mind."
    },
    "159": {
        "startTime": 1373.281,
        "endTime": 1378.952,
        "transcript": "Cali qavarturangluni tauna melugpakatuli.",
        "translation": "Also, that one who smokes too much starts sleeping all the time."
    },
    "160": {
        "startTime": 1378.96,
        "endTime": 1384.189,
        "transcript": "Tau͡gaten niitetuunga tamatumeng melugaqata.",
        "translation": "That's what I hear [happens] when they smoke."
    },
    "161": {
        "startTime": 1384.21,
        "endTime": 1390.339,
        "transcript": "Ilumuuluni tamana pituyugnarquq.",
        "translation": "I think that truly happens."
    },
    "162": {
        "startTime": 1390.346,
        "endTime": 1394.26,
        "transcript": "Melugpakalria man'a qavarturangluni.",
        "translation": "One who smokes too much sleeps all the time."
    },
    "163": {
        "startTime": 1394.276,
        "endTime": 1399.076,
        "transcript": "Cali unim[yutangluteng], you know?",
        "translation": "They also [become] forgetful, you know?"
    },
    "164": {
        "startTime": 1399.387,
        "endTime": 1407.087,
        "transcript": "They forgot what to do. Ellirraarluki-llu cat wanirpaagaq nalluyagutaqluki.",
        "translation": "They forgot what to do. And when they put things down, they immediately forget them."
    },
    "165": {
        "startTime": 1431.985,
        "endTime": 1438.114,
        "transcript": "Ataucirqumek epsarpiallruukut pavani.",
        "translation": "Once, we almost suffocated inland."
    },
    "166": {
        "startTime": 1439.197,
        "endTime": 1446.326,
        "transcript": "Pingayuuluta, kinguqliqa, au͡gna-llu Kuigglugmiungurtelleq, wiinga-llu.",
        "translation": "There were three of us, my younger sibling, that one who moved to Kwethluk, and me."
    },
    "167": {
        "startTime": 1449.762,
        "endTime": 1462.09,
        "transcript": "When we set up a tent in a deep hollow, a blizzard started at night.",
        "translation": "When we set up a tent in a deep hollow, a blizzard started at night."
    },
    "168": {
        "startTime": 1462.107,
        "endTime": 1467.121,
        "transcript": "Waten anuqlirluku pilltemteńi ellaqertelliniluni.",
        "translation": "When we [set up] when it was windy, the weather turned."
    },
    "169": {
        "startTime": 1467.132,
        "endTime": 1474.76,
        "transcript": "Uiga'rtua epsalngupiarlua. Mak'arcaaqellrianga puukarluku man'a.",
        "translation": "I opened my eyes and felt suffocated. I shot right up and hit this."
    },
    "170": {
        "startTime": 1474.777,
        "endTime": 1480.477,
        "transcript": "Cunaw' tua-i waten engillinikii qanikcaam.",
        "translation": "Apparently, the snow was weighing down on it."
    },
    "171": {
        "startTime": 1480.487,
        "endTime": 1491.801,
        "transcript": "Pegnem tuani anellruukut, akluput-llu mecungluteng, amta-ll' ella qakemna nengelvagluni.",
        "translation": "We went out after much effeort, and our things were wet, yet the weather outside was very cold."
    },
    "172": {
        "startTime": 1491.824,
        "endTime": 1499.167,
        "transcript": "Qanikcaam acia waten umcigluni kiirtulliniuq, epsalngunaqluni.",
        "translation": "Apparently, [being] under the snow if very hot and suffocating."
    },
    "173": {
        "startTime": 1499.386,
        "endTime": 1508.501,
        "transcript": "Qanikcaq tua-i waten urugturluku akluput qaingit mecunglluteng inarrviput.",
        "translation": "As the snow was melting like this, our things got wet, our bedding."
    },
    "174": {
        "startTime": 1510.524,
        "endTime": 1526.31,
        "transcript": "Taumek tamana waten inerqutullruitkut: ellaqerruskakut tuaten tua-i ilutulrianun uqitesqevkenata, qanikcautesqevkenata.",
        "translation": "That's why they would admonish us like this: if the weather turns on us, not to seek shelter in deep hollows, not to have snow fall and cover us."
    },
    "175": {
        "startTime": 1526.326,
        "endTime": 1534.24,
        "transcript": "Tau͡gaam qerkilngurmun, wall' qanikcangraan mamkitarkamun.",
        "translation": "Instead, [seek shelter] in short banks, or if there's snow, where it will be thin."
    },
    "176": {
        "startTime": 1534.541,
        "endTime": 1541.413,
        "transcript": "Waten cali ukiarrluki pikna, tuaten tua-i arulaartaqluku.",
        "translation": "Also, pierce the ceiling up there, and move [the staff] back and forth."
    },
    "177": {
        "startTime": 1543.49,
        "endTime": 1551.832,
        "transcript": "Tuamtellu cali waten nallunrilkumteggu kingunerput tekitarkaunrilkumta",
        "translation": "Then if we know that we will not arrive back home"
    },
    "178": {
        "startTime": 1551.843,
        "endTime": 1561.057,
        "transcript": "Camek-gguq kapuarciluta nunam taum ciunemta tungiinun itqilta.",
        "translation": "They said we should stick something in the ground toward our destination and go in."
    },
    "179": {
        "startTime": 1561.417,
        "endTime": 1569.76,
        "transcript": "Tua-i-gguq assirluni eruskakut",
        "translation": "They said that if dawn comes with good [weather]"
    },
    "180": {
        "startTime": 1569.773,
        "endTime": 1578.23,
        "transcript": "Imna tua-i tauna nalluvkenaku ayuquciitevkenata ciunerput amna ullagarkauluku.",
        "translation": "We will know where we are, and will go toward our destination."
    },
    "181": {
        "startTime": 1578.453,
        "endTime": 1594.109,
        "transcript": "Tang tua-i man'a au͡gna-w' tua-i elpekqallerput apertuarassiyaagumanriami-w' tua-i",
        "translation": "You see, because they don't instruct on how to discern [one's whereabouts]"
    },
    "182": {
        "startTime": 1594.126,
        "endTime": 1601.341,
        "transcript": "Wangkuta-llu apertuanriamteggu waten nallungekput.",
        "translation": "And because we don't instruct it, we don't know it anymore."
    },
    "183": {
        "startTime": 1601.353,
        "endTime": 1606.882,
        "transcript": "Cauciirulluta mat'um nalliini.",
        "translation": "We have no idea what to do these days."
    },
    "184": {
        "startTime": 1631.658,
        "endTime": 1645.644,
        "transcript": "Cali umyuaqelalqa, au͡gkut makut anglicartellemta ilaput nalluvkanritellruit.",
        "translation": "I also remember that those who raised us back then had us know our relatives."
    },
    "185": {
        "startTime": 1645.658,
        "endTime": 1660.887,
        "transcript": "Nani nunani allani uitangraata, iciw' maa-i ilu'uqniluki, angakniluki, anaanakniluki, nuliacungaqniluki.",
        "translation": "Though they lived in other villages, you know, they said they were our male cross-cousins, maternal uncles, maternal aunts, female cross-cousins."
    },
    "186": {
        "startTime": 1660.903,
        "endTime": 1664.403,
        "transcript": "Tamakut apertuamalaryaaqut.",
        "translation": "They would be pointed out."
    },
    "187": {
        "startTime": 1665.788,
        "endTime": 1676.402,
        "transcript": "Maa-i mat'um nalliini waten cakucirulluta pilriakut.",
        "translation": "These days, we don't know how we're related anymore."
    },
    "188": {
        "startTime": 1676.901,
        "endTime": 1689.486,
        "transcript": "Waten avani wangkuta waten tan'gaurlullraullemteńi apertuatetullruitkut au͡gkut anglicartemta.",
        "translation": "When we were boys like this back then, those who raised us would point out [how we were related]."
    },
    "189": {
        "startTime": 1689.501,
        "endTime": 1703.615,
        "transcript": "Waten-llu nunanek tekitaqameng ukut ilakellriit, tekitaqameng apertuatnauraitkut.",
        "translation": "And when these families arrived from other villages, they would point out [how we're related] when they arrived."
    },
    "190": {
        "startTime": 1705.439,
        "endTime": 1711.182,
        "transcript": "Wangkuta-gguq tauna-llu cakukut.",
        "translation": "They said that we and that one are related."
    },
    "191": {
        "startTime": 1711.189,
        "endTime": 1718.303,
        "transcript": "Ilu'urqukut wall' usrukukut. Tuaten tua-i.",
        "translation": "We're cross-cousins, or neices/nephews and maternal uncles. Like that."
    },
    "192": {
        "startTime": 1718.322,
        "endTime": 1726.68,
        "transcript": "Tamaaggun waten nalluyuqenriqertaqluki apertuamataqamta.",
        "translation": "Through that, we would know them when we were demonstrated [how we were related]."
    },
    "193": {
        "startTime": 1728.526,
        "endTime": 1736.183,
        "transcript": "Tau͡gken mat'um nalliini tua-i cakuciirulluta.",
        "translation": "These days, however, we don't know how we're related anymore."
    },
    "194": {
        "startTime": 1741.041,
        "endTime": 1748.784,
        "transcript": "Maaggun-llu cakuciirutlemteggun, apertuacimanritlemteggun",
        "translation": "And by now knowing how we're related, how we're not shown [how we're related]"
    },
    "195": {
        "startTime": 1748.789,
        "endTime": 1754.518,
        "transcript": "Mat'um nalliini nakukutengluteng yuut.",
        "translation": "People are starting to fight these days."
    },
    "196": {
        "startTime": 1754.736,
        "endTime": 1763.693,
        "transcript": "Amta-ll' waten ilakutaqluteng-llu ping'e'rmeng nallukulluteng.",
        "translation": "And yet, though they're related, they don't know each other."
    },
    "197": {
        "startTime": 1763.709,
        "endTime": 1767.467,
        "transcript": "Inglukutengluteng mat'um nalliini.",
        "translation": "They've started opposing each other these days."
    },
    "198": {
        "startTime": 1767.479,
        "endTime": 1772.794,
        "transcript": "Au͡gkut avani nepaitellruut yuut.",
        "translation": "People back then were peaceful."
    },
    "199": {
        "startTime": 1773.481,
        "endTime": 1779.709,
        "transcript": "Tua-i nakukutellriartaunani.",
        "translation": "There was no one fighting."
    },
    "200": {
        "startTime": 1799.452,
        "endTime": 1803.181,
        "transcript": "Assiriyaaqukut nangteqenrirluta.",
        "translation": "We've gotten better, not suffering anymore."
    },
    "201": {
        "startTime": 1803.192,
        "endTime": 1816.835,
        "transcript": "Kass'at makut aklirtungluta aturamteggun, ayagassuutemteggun, cat-ggun tua-i, neqkamteggun, makutgun-llu enetgun.",
        "translation": "The West provides us with akauterments through our clothes, transportation, different things, food, and these houses."
    },
    "202": {
        "startTime": 1817.011,
        "endTime": 1826.569,
        "transcript": "Nangteqenrirluta. Nengelvagnanrirluteng tua-i unugmi. Kiirpiurturangluta.",
        "translation": "We're not suffering anymore. They aren't cold at night anymore. We've started being in hot [home] environments."
    },
    "203": {
        "startTime": 1827.845,
        "endTime": 1831.174,
        "transcript": "Assiriyaaqluni.",
        "translation": "It's gotten better."
    },
    "204": {
        "startTime": 1831.194,
        "endTime": 1838.08,
        "transcript": "Tau͡gaam assiirulluteng, assiirulluta mat'um nalliini",
        "translation": "But they've become bad, we've become bad these days"
    },
    "205": {
        "startTime": 1838.097,
        "endTime": 1842.625,
        "transcript": "Nakukutengluteng, tuqurqutengluteng.",
        "translation": "They've started fighting, started killing each other."
    },
    "206": {
        "startTime": 1845.284,
        "endTime": 1852.669,
        "transcript": "Qaneryaram mat'um apertullra natruartevkenaku.",
        "translation": "They're exactly what the traditioanl wisdom pointed out [would happen]."
    },
    "207": {
        "startTime": 1854.449,
        "endTime": 1867.392,
        "transcript": "Kitak' waten tua-i niicugnilriani tan'gaurlurni, nasaurlurni umyuaqelarniarci au͡gna niitellerci.",
        "translation": "Now, you boys and girls who are listening, remember what you just heard."
    },
    "208": {
        "startTime": 1867.402,
        "endTime": 1873.016,
        "transcript": "Au͡gkut anglicarteput waten ayuqellrunritut.",
        "translation": "Those who raised us back then were not like this."
    },
    "209": {
        "startTime": 1873.257,
        "endTime": 1884.857,
        "transcript": "Aturanek amllernek enem iluani pitangqellrunrituq, enait waten ayuqellrunrilameng.",
        "translation": "There not a lot of possessions in the house because their houses were not like this."
    },
    "210": {
        "startTime": 1885.163,
        "endTime": 1898.649,
        "transcript": "Unugmi-llu qava'arqameng nengelvagmi qaltat tua-i makut mernek imalget cikumaluki, cikuaqluki.",
        "translation": "And when they slept at night in the cold, the little bukets filled with water would be frozen, would freeze."
    },
    "211": {
        "startTime": 1898.667,
        "endTime": 1907.952,
        "transcript": "Kaminiam-llu qainganlengraata imkut saaniget puqlanillrung'e'rmeng ilait tua-i cikumaaqluteng.",
        "translation": "And though they were on top of stoves, though those kettles had  been warm, some would be frozen."
    },
    "212": {
        "startTime": 1928.699,
        "endTime": 1934.213,
        "transcript": "Tamaani 1930s qanikcarpatullruuq tan'gurraulua.",
        "translation": "Back in the 1930s, there used to be a lot of snow when I was a boy."
    },
    "213": {
        "startTime": 1934.353,
        "endTime": 1945.353,
        "transcript": "Iliikun ungaliquluni waten qaniquluni-ll' piaqan maraq cirmiggnilaraat, cikuluni-gguq.",
        "translation": "Sometimes, when there's persistent southern winds and heavy snow, they say the marsh freezes, cirmiggluni."
    },
    "214": {
        "startTime": 1945.359,
        "endTime": 1953.445,
        "transcript": "Maa-i qanikcangqeng'e'rmi cirmigcimanrituq man'a nunapik.",
        "translation": "Though there's snow now, the tundra here is not frozen."
    },
    "215": {
        "startTime": 1954.905,
        "endTime": 1964.891,
        "transcript": "Waten qanikcing'e'rmi iliikun merpayuituq mel'ing'e'rmi, tau͡gaam cikuineq man'a enetnaciarlartuq.",
        "translation": "Though there's a lot of snow, sometimes there's not a great flood of water, though there's a lot of water, but the melted ice ebbs out late."
    },
    "216": {
        "startTime": 1964.904,
        "endTime": 1971.733,
        "transcript": "Tamaa-i-gguq aipaagni qerruvkaqtaarluni merkani nangciqaa.",
        "translation": "They said it would probably freeze repeatedly and deplete its water."
    },
    "217": {
        "startTime": 1972.256,
        "endTime": 1978.742,
        "transcript": "Tau͡gaam imumek cikuugaqami tuatnasciigataqan nutaan merpaglartuq.",
        "translation": "But when it's ice and can't do that, there's a great flood of water."
    },
    "218": {
        "startTime": 1978.75,
        "endTime": 1984.178,
        "transcript": "Cali makut kuiget qanikcarmek amllermek imangqerrluteng cali ciku mamtunrituq.",
        "translation": "Also, when rivers have a lot of snow, the ice isn't thick."
    },
    "219": {
        "startTime": 1984.199,
        "endTime": 1993.942,
        "transcript": "Mamtulaucimitun mamtunrilan imartung'e'rmi ulerpagnayukluku wii umyuarteqenritua tamatumek picirluku.",
        "translation": "Since it's not as thick as it usually is, I don't think that it'll flood though there's a lot of water for that reason."
    },
    "220": {
        "startTime": 1994.079,
        "endTime": 2001.236,
        "transcript": "Tamaani-qaa yuut wani nengelvakaya'gqan, maa-i-cetun ayuqenrilnguq nallunrilken.",
        "translation": "Back when it would get very cold, it's not like now as you know."
    },
    "221": {
        "startTime": 2001.255,
        "endTime": 2003.498,
        "transcript": "Qerrulrianek-qaa niitelallruuten?",
        "translation": "Would you hear of anyone freezing to death?"
    },
    "222": {
        "startTime": 2003.503,
        "endTime": 2009.203,
        "transcript": "Qerrulrianek niicuitellruukut maqartulrianek melqulegnek aturangqetullruamta.",
        "translation": "We didn't hear of anyone freezing because we had warm fur clothes."
    },
    "223": {
        "startTime": 2009.218,
        "endTime": 2014.375,
        "transcript": "Maa-i cali nenglling'e'rmi nengllirlallni tekiteksaitaa.",
        "translation": "Though it also gets cold now, it doesn't get as cold as it used to."
    },
    "224": {
        "startTime": 2014.479,
        "endTime": 2023.508,
        "transcript": "Wangkuta tua-i maa-i elluatunek aturangqerrnanriamta nengllicuaqerqan nengllirniluku piyugtukut.",
        "translation": "Since we don't have good [warm] clothes anymore,  when it gest a little cold, we like to say it's cold."
    },
    "225": {
        "startTime": 2049.986,
        "endTime": 2058.07,
        "transcript": "Waten tan'gaurluullemni, tan'gaurluullemteńi makunek",
        "translation": "These things when I was a boy like this, when we were boys"
    },
    "226": {
        "startTime": 2059.607,
        "endTime": 2073.421,
        "transcript": "Makunek-wa tua-i nunam qainganelngurnek neqemteńek, pitarkanek, imarpigmiutaat, makut-llu cali yaqulget.",
        "translation": "These things on land were our food sources, animals to catch, marine animals, and these birds."
    },
    "227": {
        "startTime": 2073.841,
        "endTime": 2080.769,
        "transcript": "Maa-i mat'um nalliini nang'ut.",
        "translation": "These days, they are depleting."
    },
    "228": {
        "startTime": 2081.942,
        "endTime": 2088.685,
        "transcript": "Makut waten imarpigmiutaat enurnaringut.",
        "translation": "These marine animals are getting scarce now."
    },
    "229": {
        "startTime": 2088.693,
        "endTime": 2095.093,
        "transcript": "Makut-llu yaqulget cali enurnaringluteng.",
        "translation": "These birds are also getting scarce."
    },
    "230": {
        "startTime": 2095.112,
        "endTime": 2108.241,
        "transcript": "Imumi waten tan'gaurluulltemteńi, tan'gaurluullemni-w' tua-i up'nerkami amllepiatullruut yaqulget.",
        "translation": "Back when we were boys, at least when I was a boy, there used to be very many birds."
    },
    "231": {
        "startTime": 2108.962,
        "endTime": 2116.176,
        "transcript": "Yuilquq nepaitellruuq. Waten ayuqellrunrituq.",
        "translation": "The wilderness was quiet. It wasn't like this [now]."
    },
    "232": {
        "startTime": 2116.187,
        "endTime": 2124.73,
        "transcript": "Tem'ingelriamek waten niicuunata ertaqan, ellami tem'irtellrianek.",
        "translation": "We wouldn't hear anything rumbling at dawn, things rumbling outside."
    },
    "233": {
        "startTime": 2124.866,
        "endTime": 2133.738,
        "transcript": "Up'nerkami waten up'nerkiaqameng pavani Akulmi nunanirpak.",
        "translation": "When they went to spring camp at spring inland in the Akula region, it was wonderful."
    },
    "234": {
        "startTime": 2133.95,
        "endTime": 2138.622,
        "transcript": "Yaqulget ayuqenrilnguut qalrialuteng.",
        "translation": "Different kinds of birds called."
    },
    "235": {
        "startTime": 2142.073,
        "endTime": 2153.544,
        "transcript": "Makut-llu pissulriit waten atakumi, atakuara'rqan atakuaratullruut kanaqlagcualriit up'nerkillerni pavani.",
        "translation": "And these hunters in the evening, in the early evening, the muskrat hunters would spend the evening [doing that] in the spring camps inland."
    },
    "236": {
        "startTime": 2153.866,
        "endTime": 2161.566,
        "transcript": "Tua-i cingqullagangnaurtut. Nut'galriarurrluni waten tua-i piciatun.",
        "translation": "They would start popping. The air would be filled with gunshots everywhere like this."
    },
    "237": {
        "startTime": 2161.667,
        "endTime": 2171.724,
        "transcript": "Makut-wa yaqulget pavani nanvat ceńaitni-ll' up'nerkitullruameng",
        "translation": "And these birds inland, since they would set up spring camps on lake shores"
    },
    "238": {
        "startTime": 2171.736,
        "endTime": 2177.493,
        "transcript": "Anglanaqluteng yaqulget kuimalriit qalrialuteng.",
        "translation": "It was fun with the birds swimming and calling."
    },
    "239": {
        "startTime": 2180.483,
        "endTime": 2186.354,
        "transcript": "Nunaniqluni tua-i piaqluni up'nerkami.",
        "translation": "It would be wonderful in the spring."
    },
    "240": {
        "startTime": 2210.734,
        "endTime": 2219.848,
        "transcript": "Tuaten tua-i nunakameggnun ayagaqameng waten enekanek-llu [?]qucirturluteng waten itratullrulriit makiut",
        "translation": "When they traveled to their settlements, they would go upriver and [?] what they would use for their houses"
    },
    "241": {
        "startTime": 2219.861,
        "endTime": 2225.061,
        "transcript": "Kuigem ceńiini uitatullruameng imkut nunat uksillerni.",
        "translation": "Because those winter camp settlements would be on the riverbank."
    },
    "242": {
        "startTime": 2225.08,
        "endTime": 2227.78,
        "transcript": "Tua-i-ll' tekiskuneng",
        "translation": "Then when they arrived"
    },
    "243": {
        "startTime": 2229.551,
        "endTime": 2238.308,
        "transcript": "Tamakut tamaa-i malikek'ngateng cat wall'u tua-i canek muraganek itraulluteng pinrilkuneng tekicimarikuneng",
        "translation": "Those things that they brought with them, if they arrived without having brought wood upriver"
    },
    "244": {
        "startTime": 2238.324,
        "endTime": 2243.138,
        "transcript": "Angutet quyurrluteng taukut piarkaqutellriit ilakelriit.",
        "translation": "Those related men who work together would gather."
    },
    "245": {
        "startTime": 2243.154,
        "endTime": 2247.854,
        "transcript": "Angyakun ayagluteng imumek angyamek Yup'igtarmek aturluteng..",
        "translation": "They would travel with a Yup'ik boat."
    },
    "246": {
        "startTime": 2247.866,
        "endTime": 2255.052,
        "transcript": "[?] tuaten tua-i enekanek muraganek ucilirluku itrautaqluku.",
        "translation": "They would load it with [?] and even wood for houses and bring it upriver."
    },
    "247": {
        "startTime": 2255.066,
        "endTime": 2264.352,
        "transcript": "Waten-llu tua-i tekiskuneng waten [?] eneliluteng ikayuqluteng imkut ilakuralriit, makut piarkaqutellriit.",
        "translation": "Then when they arrived like this, those relatevies who work together would help each other to build a house."
    },
    "248": {
        "startTime": 2264.682,
        "endTime": 2273.482,
        "transcript": "Tua-i tamaa-i uksurpak enekameggnek enekarteng tauna caliluku ukut ilakelriit piarkaqutellriit.",
        "translation": "Those relatives who work together would work on that house they would stay in for the winter."
    },
    "249": {
        "startTime": 2274.631,
        "endTime": 2280.146,
        "transcript": "Tua-i-llu enengureskan tua-i iternarikan itquneng",
        "translation": "Then when the house is done and it's time to go in, when they go in"
    },
    "250": {
        "startTime": 2280.167,
        "endTime": 2286.067,
        "transcript": "Imkut ataucim-llu yuut pivkenateng, imkut family-t qavciunguluteng.",
        "translation": "There wouldn't be a sing person, but familes with several members."
    },
    "251": {
        "startTime": 2286.082,
        "endTime": 2294.911,
        "transcript": "Cetamainguyaqlegukuneng enem iluani family-t, ukut-wa cali, waniw' cali akiani, wani-llu.",
        "translation": "If there are four familes in one house, these will be here, and on the other side here, and here."
    },
    "252": {
        "startTime": 2294.925,
        "endTime": 2299.125,
        "transcript": "Cetamainguluteng imkut family-nek imkut pitukait Kass'at.",
        "translation": "There are four of what they call families in English."
    },
    "253": {
        "startTime": 2299.409,
        "endTime": 2307.723,
        "transcript": "Tauna atauciq yugyagluteng enekluku, tamaa-i ilakutellriit imkut.",
        "translation": "There would be a lot of people in that one house, those relatives."
    },
    "254": {
        "startTime": 2307.733,
        "endTime": 2315.39,
        "transcript": "Cali-llu tamakut waten tamaani enemi uitallermeggni makut neqkaaraat, neqkat",
        "translation": "Also, when they were there in that house, these food sources"
    },
    "255": {
        "startTime": 2317.006,
        "endTime": 2327.706,
        "transcript": "Taukut family-t kiimeng pivkenaki, ukut enemiut tamarmeng tua-i neqekluki piaqluki tamakut neqkateng, neqkaukarateng.",
        "translation": "That one family alone wouldn't have them, but everyone in that house would eat from what food they had."
    },
    "256": {
        "startTime": 2328.455,
        "endTime": 2339.683,
        "transcript": "Ilait tua-i enengqetuyaaqut, yuungnaquralriit-ll' ataucimek kiimeng enem iluani uitaluteng enekaqluku.",
        "translation": "Some would have [their own] houses, where those who provide for their [nuclear] families would live in one house."
    },
    "257": {
        "startTime": 2339.699,
        "endTime": 2343.927,
        "transcript": "Tua-i tau͡gaam tuaten yugyagglainatull[ruut].",
        "translation": "But there would always be a lot of people in them."
    },
    "258": {
        "startTime": 2343.934,
        "endTime": 2352.848,
        "transcript": "Tua-i-w' ukut ilakelriit qavciunguluteng enem iluani uitatullruut, ilakellriit tua-i.",
        "translation": "These several [nuclear] families would live in the house, those relatives."
    },
    "259": {
        "startTime": 2352.867,
        "endTime": 2355.995,
        "transcript": "Tuaten tua-i ayuquciqellruat tamana.",
        "translation": "That's what they were like."
    },
    "260": {
        "startTime": 2356.014,
        "endTime": 2367.642,
        "transcript": "Cali tamana neqkarteng yuilqumek unangkengateng can'giiret, iqalluat, wall' piciatun-wa tua-i neqet, uksumi, uksuarmi pitaqetukiit kumlanret",
        "translation": "Also, their food stores that they got from the wilderness, blackfish, saffron cod, or various fish that they catch in winter, fall to eat frozen"
    },
    "261": {
        "startTime": 2367.654,
        "endTime": 2382.168,
        "transcript": "Enem iluani tua-i taukut-llu pitaqestaita kiimeng pivkenaki, enem tau͡gaam iluanelnguut tamarmeng, amani-llu qasgimi anguteteng ilakluki tua-i neqkautekaqluki tauna neqa.",
        "translation": "Inside the house, and not only for the ones who caught them, but that food would be for everyone in that house, including their men over in the community house."
    },
    "262": {
        "startTime": 2383.654,
        "endTime": 2388.097,
        "transcript": "Tuaten tua-i ayuqetullruut au͡gkut tangvak'ngaput.",
        "translation": "That's what those we watched back then were like."
    },
    "263": {
        "startTime": 2417.111,
        "endTime": 2423.983,
        "transcript": "Wangkuta-llu tan'gaurlucuarni cali waten elitnauruterluta:",
        "translation": "We small boy also had this learning experience:"
    },
    "264": {
        "startTime": 2423.991,
        "endTime": 2430.548,
        "transcript": "Pissungqerrluta makunek yaquleyagarnek.",
        "translation": "We would hunt these little birds."
    },
    "265": {
        "startTime": 2430.77,
        "endTime": 2433.641,
        "transcript": "Amllepiarluteng cali.",
        "translation": "There were also a lot of them."
    },
    "266": {
        "startTime": 2433.643,
        "endTime": 2441.114,
        "transcript": "Pitgaquurluki tamakunek yaquleyagarnek pissurnaurtukut.",
        "translation": "We would hunt those little birds by shooting arrows at them."
    },
    "267": {
        "startTime": 2441.355,
        "endTime": 2448.741,
        "transcript": "Tamakut-llu pitaput iciw' egcuunaki.",
        "translation": "And, you know, they wouldn't throw away what we caught."
    },
    "268": {
        "startTime": 2448.744,
        "endTime": 2459.015,
        "transcript": "Makut cali nasaurlullraat meqtayagarluki kenirnaurait.",
        "translation": "These little girls would also pluck their feathers and cook them."
    },
    "269": {
        "startTime": 2459.212,
        "endTime": 2468.083,
        "transcript": "Tau͡gken cali aanamta imum keniraqluki cali pitaput, egcuunaki.",
        "translation": "However, our mother would also cook what we caught, not throw them away."
    },
    "270": {
        "startTime": 2468.099,
        "endTime": 2477.985,
        "transcript": "Waten qigcikluki, makut nunamiutaat neqput kencikluki au͡gkut pitullruit.",
        "translation": "They respected them like this, those poeple back then revered the food that we caught from the land."
    },
    "271": {
        "startTime": 2480.098,
        "endTime": 2484.241,
        "transcript": "Mat'um tau͡gken tua-i nalliini qaillun piat?",
        "translation": "These days, however, what are they doing?"
    },
    "272": {
        "startTime": 2484.251,
        "endTime": 2495.136,
        "transcript": "Makut-llu yup'ut pissuyuirulluki imkut makut yaquleyagaat pitgaquurluki pitulput.",
        "translation": "And our children no longer hunt these little birds that we used to shoot arrows at."
    },
    "273": {
        "startTime": 2495.151,
        "endTime": 2505.394,
        "transcript": "Tayima tua-i tangrrunanrirluteng maani nunam qaingani up'nerkami pissulalput.",
        "translation": "They things that we used to hunt in the spring are no longer seen here on the land."
    },
    "274": {
        "startTime": 2505.719,
        "endTime": 2513.433,
        "transcript": "Tuamtellu cali kiagmi tukraqameng napamiutaat",
        "translation": "Then when the birds in the trees hatched in the summer"
    },
    "275": {
        "startTime": 2513.443,
        "endTime": 2519.243,
        "transcript": "Amllepiarluteng puyurcivignun it'raluteng.",
        "translation": "There would be very many going into smoke houses."
    },
    "276": {
        "startTime": 2519.258,
        "endTime": 2524.043,
        "transcript": "Wangkuta-wa cali maa-i pitgaquurqeput.",
        "translation": "We would also shoot them with arrows."
    },
    "277": {
        "startTime": 2526.623,
        "endTime": 2533.138,
        "transcript": "Amiiyaarluki, uuggun qat'gaitgun cilla'arrluki kemgit au͡g'arluki",
        "translation": "We would skin the little things, open them up from their chests and remove their flesh"
    },
    "278": {
        "startTime": 2533.148,
        "endTime": 2538.633,
        "transcript": "Uuggun-llu yaqruita piitgun ayagciqerluki",
        "translation": "And prop the here on their wings"
    },
    "279": {
        "startTime": 2538.644,
        "endTime": 2543.458,
        "transcript": "Nuucirluki-ll' nutaan napamek agarqurluki.",
        "translation": "Then thread them through and hang them on trees."
    },
    "280": {
        "startTime": 2544.239,
        "endTime": 2551.482,
        "transcript": "Wagg'uq-qaa nakaculiluki. Tuaten pitullruut.",
        "translation": "They called that nakaculiluki, \"making them into bladders.\" That's what they did."
    },
    "281": {
        "startTime": 2552.022,
        "endTime": 2557.608,
        "transcript": "Amllepiarluteng yaquleyagaat cakaniyuunateng.",
        "translation": "There were many little birds, and they wouldn't deplete."
    },
    "282": {
        "startTime": 2583.636,
        "endTime": 2595.836,
        "transcript": "Makut-wa cali aulukesteput up'nerkamek tua-i ayagluteng yaqulget waten cetunatkameggnun",
        "translation": "Our caretakers here, starting from the spring until the birds went downriver like this"
    },
    "283": {
        "startTime": 2596.444,
        "endTime": 2602.344,
        "transcript": "Ner'aqluki tua-i neqekluki, kayanguit-llu.",
        "translation": "They would eat them as a food source, including their eggs."
    },
    "284": {
        "startTime": 2602.369,
        "endTime": 2608.012,
        "transcript": "Camek niicuunata nangqatalrianek, ikeggliinalrianek.",
        "translation": "We wouldn't hear anything about them depleting or population drops."
    },
    "285": {
        "startTime": 2608.021,
        "endTime": 2616.706,
        "transcript": "Tau͡gaam waten pitullruut: allamiaquaqan cat ukut ikgetaqluteng",
        "translation": "But they would do this: every year, something would be low in numbers"
    },
    "286": {
        "startTime": 2617.1,
        "endTime": 2622.557,
        "transcript": "Caaqameng-ll' amllerrluteng, waten ikgeliqetaarluteng.",
        "translation": "And sometimes there would be a lot, with fluctuating populations."
    },
    "287": {
        "startTime": 2622.563,
        "endTime": 2626.349,
        "transcript": "Tau͡gaam nangyuunateng, cakaniyuunateng.",
        "translation": "But they wouldn't deplete, wouldn't go exctinct."
    },
    "288": {
        "startTime": 2626.358,
        "endTime": 2633.172,
        "transcript": "Amllerrlainarluteng yaqulget imarpigmiutaat-llu.",
        "translation": "There were always a lot of birds and marine animals."
    },
    "289": {
        "startTime": 2633.195,
        "endTime": 2643.138,
        "transcript": "Tua-i-llu tamakut waten yaqulget up'nerkami nerluki yaavet tua-i neq'ngellerkaanun.",
        "translation": "Then they would eat birds in the spring like this until there were fish."
    },
    "290": {
        "startTime": 2643.143,
        "endTime": 2647.771,
        "transcript": "Cetuameng tau͡gaam taqluki, ayanqigtevkenateng.",
        "translation": "They only stopped when they went downriver, wouldn't go [hunt them] again."
    },
    "291": {
        "startTime": 2647.781,
        "endTime": 2657.881,
        "transcript": "Nuna tua-i yugtairulluku waten Akula, unani tua͡gaam Kusquqvagmi.",
        "translation": "There would be no one left in the Akula region, only down on the Kuskokwim."
    },
    "292": {
        "startTime": 2657.891,
        "endTime": 2664.763,
        "transcript": "Neqnun cali cauluteng. Amllepiarluteng call' neqet.",
        "translation": "They also turned to fish. There were also a lot of fish."
    },
    "293": {
        "startTime": 2666.666,
        "endTime": 2682.066,
        "transcript": "Tamaaggun-wa kencikellratgun, Agayutem cikiutekngamiki kencikellratgun tua-i amllerrlainartelluki.",
        "translation": "Through their reverence, since they're God's gifts and they were revered, he always kept them in large numbers."
    },
    "294": {
        "startTime": 2682.484,
        "endTime": 2694.355,
        "transcript": "Maa-i mat'um nalliini umyuangcarqama, tamakut neqrateng tua-i makut neqteng murilkelluki, mulngakluki.",
        "translation": "When I think about these these days, those people kept a close eye on and were careful with whatever food they had."
    },
    "295": {
        "startTime": 2694.414,
        "endTime": 2699.714,
        "transcript": "Neq'lipiatullruuq agaani waten tan'gaurlullraullemteńi.",
        "translation": "There used to be a lot of fish across there when we were boys like this."
    },
    "296": {
        "startTime": 2700.584,
        "endTime": 2704.599,
        "transcript": "Puukaquaqluteng-llu maavet ceńamun.",
        "translation": "And they would ram into the bank here."
    },
    "297": {
        "startTime": 2704.613,
        "endTime": 2713.199,
        "transcript": "Kuimarqamta-llu iliini maaggun naw'un puukaraqluta neqet.",
        "translation": "And when we swam, sometimes the fish would ram into us somewhere here."
    },
    "298": {
        "startTime": 2713.991,
        "endTime": 2724.905,
        "transcript": "Tua-i-llu mat'um nalliini tua-i kencikenriamceteng cat nangengluteng.",
        "translation": "Then since we don't revere them these days, things are depleting."
    },
    "299": {
        "startTime": 2750.461,
        "endTime": 2761.431,
        "transcript": "Tuamtellu cetuanek makut piaqata inerqurnauraitkut ivraasqevkenata, tayim' cetuarcurqata.",
        "translation": "Then when they hunted beluga, they would admonish us against ever wading, when they hunted beluga."
    },
    "300": {
        "startTime": 2761.452,
        "endTime": 2769.609,
        "transcript": "Maavet ukalirnermun agaantaqamta ivraqaasqevkenata inerquanauraitkut.",
        "translation": "When we were across there on this side, they would admonish us against ever wading."
    },
    "301": {
        "startTime": 2769.627,
        "endTime": 2776.97,
        "transcript": "Cetuarcurniluki tamakut qaill' pilriit, tuaten inerqutullruitkut.",
        "translation": "Saying that those people were hunting beluga, they admonished us like that."
    },
    "302": {
        "startTime": 2777.73,
        "endTime": 2785.816,
        "transcript": "Tua-i-llu mat'um nalliini tayim' nangluteng pissuyuirucamceteng.",
        "translation": "Then there are no more these days because we don't hunt them anymore."
    },
    "303": {
        "startTime": 2785.842,
        "endTime": 2797.199,
        "transcript": "Makut-ll' imkut yaquleyagaat nangluteng tayima pissurnanriimceteng wangkuta pitgaquurluki.",
        "translation": "And there are no more of these little birds because we don't hunt them with arrows anymore."
    },
    "304": {
        "startTime": 2798.21,
        "endTime": 2808.924,
        "transcript": "Tau͡gken makut aipaimta kellutestaita amllericangnaqsaaqluki inerquuteksagulluki",
        "translation": "However, our counterparts who regulate them have put restrictions to try to raise their numbers"
    },
    "305": {
        "startTime": 2808.94,
        "endTime": 2814.14,
        "transcript": "Pissuyuirutevkarluki yaqulget.",
        "translation": "Having us stop hunting birds."
    },
    "306": {
        "startTime": 2814.88,
        "endTime": 2821.323,
        "transcript": "Makut yaqulget arulairucuitellruit au͡gkut anglicartemta.",
        "translation": "Those who raised us back then didn't stop [hunting] these birds."
    },
    "307": {
        "startTime": 2821.329,
        "endTime": 2829.558,
        "transcript": "Tua-i waten pavani up'nerkami neqkerraarluki, tua-i-ll' cali cetuameng",
        "translation": "After it was their food source inland in the spring, then when they went downriver"
    },
    "308": {
        "startTime": 2830.983,
        "endTime": 2839.125,
        "transcript": "Neqnek pirraarluteng, imkut tengesciigaliata ingcata, piyagaat-llu",
        "translation": "After they fished, when they molted and couldn't fly, along with their chicks"
    },
    "309": {
        "startTime": 2839.275,
        "endTime": 2850.747,
        "transcript": "Irniarit angtateksaguarcata nutaan cali tamakut pissungluki. Qayateng imirluki tekirqengnaurtut.",
        "translation": "When their offspring grew to the same size, they hunted those too. They would return with full kayaks."
    },
    "310": {
        "startTime": 2852.708,
        "endTime": 2857.751,
        "transcript": "Cakaniyuunateng-llu, ikeggliyuunateng.",
        "translation": "And they wouldn't be affected, wouldn't decrease."
    },
    "311": {
        "startTime": 2858.298,
        "endTime": 2864.512,
        "transcript": "Mat'um tau͡gken tua-i nalliini cat tamangluteng, yaquleyagaat-llu.",
        "translation": "These days, however, thigns are disappearing, including little birds."
    },
    "312": {
        "startTime": 2864.525,
        "endTime": 2869.954,
        "transcript": "Wall'u-qaa tua-i pissurnanriimceteng piut?",
        "translation": "Or is it because we don't hunt them anymore?"
    },
    "313": {
        "startTime": 2897.438,
        "endTime": 2907.194,
        "transcript": "Uitainanemni maaten imna qimugteka piaqa ak'a amiik au͡gna iriatengllinikii tua-i, aren camek pingatqapiggluni.",
        "translation": "As I sat there, I found my dog was already rocking back and forth in the door, oh my, as if sensing something."
    },
    "314": {
        "startTime": 2907.213,
        "endTime": 2913.684,
        "transcript": "Umyuartequa, \"Qayumi, tua-i piqataaraanga waniw' tua-i.\"",
        "translation": "I thought, \"As expected, it's going to get me now.\""
    },
    "315": {
        "startTime": 2913.69,
        "endTime": 2923.962,
        "transcript": "Aren tua-i uitalua. Uitainanemni atam iternerngalngurmun qaterrluni itraaralria.",
        "translation": "Oh my, I stayed still. As I stayed still, you see, something that looked like white steam slowly came in."
    },
    "316": {
        "startTime": 2923.983,
        "endTime": 2928.24,
        "transcript": "Qaillun-llu pitaqerluni tayim' amuluni anluni.",
        "translation": "Then at some point, it retracted and went out."
    },
    "317": {
        "startTime": 2928.255,
        "endTime": 2933.155,
        "transcript": "Umyuarteqa'artua, \"Uumiku pikanirluni piciquq.\"",
        "translation": "A thought came to mind, \"It'll come closer next time.\""
    },
    "318": {
        "startTime": 2933.16,
        "endTime": 2942.86,
        "transcript": "Qimugteka-ll' una maani tarrangarrluni. Tua-i nallunauani wangtun alingluni. Alingluni tua-i.",
        "translation": "And my dog started pacing here. It was clear it was afraid like me. It was afraid."
    },
    "319": {
        "startTime": 2943.067,
        "endTime": 2952.039,
        "transcript": "Uumikuan' piqerlua piunga nutaan arcarikanirluni, qengagmiaraluni tuaten, qilugyarpiaraqluni.",
        "translation": "Then next time, it got worse, even waving its nose around, and almost barking."
    },
    "320": {
        "startTime": 2952.054,
        "endTime": 2957.081,
        "transcript": "Pinga'arteqerluni atam iterneq man'a itralria.",
        "translation": "Eventually, you see, this steam starting coming in."
    },
    "321": {
        "startTime": 2957.096,
        "endTime": 2967.154,
        "transcript": "Ak'akirraq tua-i qukaqerluku nutaan atam nucuan, qimugteka imna tunumnun pamavet tagluni.",
        "translation": "When it finally retracted after reaching the middle, my dog went behind me."
    },
    "322": {
        "startTime": 2967.166,
        "endTime": 2974.438,
        "transcript": "Pama-i qemirrlumni sugg'egni pulallukek pamavet uitaqertuq.",
        "translation": "Behind me, it put its snout on my spine and stayed."
    },
    "323": {
        "startTime": 2974.446,
        "endTime": 2981.36,
        "transcript": "Tamana iterneq uatmurquraan, tamana tua-i anngan",
        "translation": "When that steam went toward the door, when it went out"
    },
    "324": {
        "startTime": 2981.372,
        "endTime": 2987.386,
        "transcript": "Qimugteḿa tang pam'um sugg'egminek cinguuqiliu tunuka.",
        "translation": "My dog behind me started pushing my back with its snout."
    },
    "325": {
        "startTime": 2987.403,
        "endTime": 2993.26,
        "transcript": "Umyuarteqa'artua, \"Uum tang anesqessugnarqekiinga.\"",
        "translation": "A thought came to mind, \"This [dog] probably wants me to go out.\""
    },
    "326": {
        "startTime": 2993.274,
        "endTime": 3003.402,
        "transcript": "Aren uitangnaqa'arcaaqvimnek inarrvicualleraak atkucualle'rqa-ll' as'arrluku",
        "translation": "Oh my, after I tried to stay, I [rolled up] my bedding, and put on my parka"
    },
    "327": {
        "startTime": 3003.421,
        "endTime": 3011.121,
        "transcript": "Taukuk tua-i inarrvicualler imkarluku, nemkarluku, nacaqerlua-llu anlua.",
        "translation": "I rolled up and bound my bedding, put on my hat, and went out."
    },
    "328": {
        "startTime": 3011.134,
        "endTime": 3020.448,
        "transcript": "Uavet una iteryaraq uaqliq lumarrallermek agalriartangqertuq.",
        "translation": "There was a piece of cloth hanging here on the outer entrance."
    },
    "329": {
        "startTime": 3020.468,
        "endTime": 3024.482,
        "transcript": "Qakmavet tau͡gken anyaraq amiipiuluni.",
        "translation": "But the exit to outside was a real door."
    },
    "330": {
        "startTime": 3024.489,
        "endTime": 3035.132,
        "transcript": "Tauna tua-i waniw' anqataama, nacaqaama kenurrak taukuk cupqaqenka tua-i uivetmun. Nipluki tua-i.",
        "translation": "When I was going to go out, when I put on my hand, I blew on those lamps in an arc. I turned them off."
    },
    "331": {
        "startTime": 3035.156,
        "endTime": 3046.427,
        "transcript": "Aren tua-i amik cuqluku anelrarlua, tauna tekicamku lumarralleq, qakugcamun imumun puukarlii alikek'ngamnun.",
        "translation": "Oh my, when I went out measuring the door, when I reached that cloth, I bumped into that [?qakugcaq] that I was afraid of."
    },
    "332": {
        "startTime": 3047.213,
        "endTime": 3052.885,
        "transcript": "Aren pivailemku ankilii ellamun.",
        "translation": "Oh my, before I [hit] it, I went outside."
    },
    "333": {
        "startTime": 3052.886,
        "endTime": 3058.686,
        "transcript": "Anngama ellamun ukalirnetmun, iqlutun-llu tang pillruyaaqelliniunga",
        "translation": "When I went out, I went this way, and I think I went the wrong way"
    },
    "334": {
        "startTime": 3058.702,
        "endTime": 3065.717,
        "transcript": "Akertem ayagyaraa maliggluku uivesqelarngatellruitki.",
        "translation": "Because I think they said to go around it following the way the sun goes."
    },
    "335": {
        "startTime": 3065.735,
        "endTime": 3071.421,
        "transcript": "Kiarteksaunii-ll' tua-i, kiingan tau͡gaam acika paallallerkaqa tau͡gaam.",
        "translation": "And I didn't look around, only for what I would trip over below me."
    },
    "336": {
        "startTime": 3071.435,
        "endTime": 3075.735,
        "transcript": "Kassuamku tua-i avateka-ll' man'a tangeqsaunaku.",
        "translation": "When I went around it, I didn't look around me."
    },
    "337": {
        "startTime": 3075.754,
        "endTime": 3080.712,
        "transcript": "Qimugta tauna tua-i sagtanka pingayurraungata qimugtenka.",
        "translation": "I spread out my dogs because I only had three dogs."
    },
    "338": {
        "startTime": 3080.717,
        "endTime": 3088.317,
        "transcript": "Saagarcamki ciulisteka im' taikili tuavet tua-i ciulistem eksraanun.",
        "translation": "When I spread them out, my lead dog came to the lead dog's spot."
    },
    "339": {
        "startTime": 3088.333,
        "endTime": 3098.919,
        "transcript": "Qamiqurra tang uskuragnek ac'amku ellminek tang una picetaarpek'nani imkuk ukuk askilikek elavluni-llu.",
        "translation": "When I put the harness on it, it put them on by itself without being told to, and crouched."
    },
    "340": {
        "startTime": 3098.931,
        "endTime": 3107.886,
        "transcript": "Tuamtell' taukuk tua-i uskurarraarlukek tua-i kiarteksauna[ni], una tau͡gaam tua-i tangvallra kiingan tangvagluku.",
        "translation": "Then after I harnessed it, it didn't look around except what it was watching [in front of it]."
    },
    "341": {
        "startTime": 3108.25,
        "endTime": 3112.85,
        "transcript": "Aren imkut tua-i qaqicamki hait-aartut.",
        "translation": "Oh my, when I finished them, I went hait."
    },
    "342": {
        "startTime": 3112.87,
        "endTime": 3117.034,
        "transcript": "Tuar tang snuukuuq ayaga'rtua [?].",
        "translation": "It seemed like a snowgo when I went."
    },
    "343": {
        "startTime": 3117.034,
        "endTime": 3124.048,
        "transcript": "Aren alingqapiar[lua] [?] pamaken tegulaki.",
        "translation": "Oh my, I was so scared that [?] would take me from behind."
    },
    "344": {
        "startTime": 3124.375,
        "endTime": 3129.104,
        "transcript": "Tua-i tang qimugtemnek taumek irr'illruunga.",
        "translation": "You see, I was amazed by my dog."
    },
    "345": {
        "startTime": 3129.116,
        "endTime": 3136.673,
        "transcript": "Ikayuqapiarallrukiinga tuani tua-i. Anesqellua tua-i nallunailngurmek cinguurlua.",
        "translation": "It helped me a lot at that time. It pushed me, clearly wanting me to go out."
    },
    "346": {
        "startTime": 3163.43,
        "endTime": 3174.759,
        "transcript": "Amllerrssaaqut ayuqucirtuuteput, ayuqucirtuutek'lalput wangkuta-w' tua-i ayagyuani apa'urlungqellriani apa'urlumta qanruyutek'lallriit.",
        "translation": "There are many instructions, instructions for us young people, the traditional wisdom of our grandfathers for those of us who have grandfathers."
    },
    "347": {
        "startTime": 3174.774,
        "endTime": 3180.403,
        "transcript": "Cali tuamtellu nunat elatiitnun elliqumta",
        "translation": "Also, when we reached the areas right outside of villages"
    },
    "348": {
        "startTime": 3180.428,
        "endTime": 3188.57,
        "transcript": "Uksuarmi waten pitullruanga: nunat-gguq elatiitnun elliquma, qertulriamek tangerquma",
        "translation": "He would tell me this in the fall: if I reach the area right outside of a village and see an elevated hill"
    },
    "349": {
        "startTime": 3188.573,
        "endTime": 3195.873,
        "transcript": "Ullagluku qainganun mayurlua avateka kiareskilaku, nunat avatiit kiareskilaku",
        "translation": "I should go to it, climb it, and look around me, look around the village"
    },
    "350": {
        "startTime": 3195.898,
        "endTime": 3199.512,
        "transcript": "Nallunairturluki ukut nunat.",
        "translation": "Making mental maps of these villages."
    },
    "351": {
        "startTime": 3200.619,
        "endTime": 3211.633,
        "transcript": "Una tua-i qertulria, makut-llu qertuuralriit, nanvat-llu makut qertuuralriarit ceńaitni murilkelluki cakneq.",
        "translation": "I should pay very close attention to this elevated hill, these elevated hills, and the lakes around these elevated hills."
    },
    "352": {
        "startTime": 3211.646,
        "endTime": 3218.118,
        "transcript": "Tamaa-i-gguq anirtuutekaqanka ella assiiruskan nalluyagutailkuma.",
        "translation": "He said those will save me when the weather turns bad if I'm not forgetful"
    },
    "353": {
        "startTime": 3218.136,
        "endTime": 3222.893,
        "transcript": "Tau͡gaam tua-i wiinga atuqsaitellruanka tamakut.",
        "translation": "But I didn't practice those."
    },
    "354": {
        "startTime": 3222.911,
        "endTime": 3231.282,
        "transcript": "Nalluyaguqurluki-w' tua-i pilallruama imumi, iliini tau͡gaam tua-i nallunritaqluki.",
        "translation": "I used to forget them all the time back then, but I would sometimes know them."
    },
    "355": {
        "startTime": 3231.299,
        "endTime": 3240.542,
        "transcript": "Tuamtellu pinauraanga, \"Cacetulria-gguq arenqiallugtellerkaminun tau͡gaam tekitaatuuq\"",
        "translation": "Then he would tell me, \"An overconfident person only comes to misfortune\""
    },
    "356": {
        "startTime": 3240.9,
        "endTime": 3244.771,
        "transcript": "Apqiitnek cacetulria.",
        "translation": "As they say, an overconfident person."
    },
    "357": {
        "startTime": 3245.082,
        "endTime": 3255.368,
        "transcript": "Tau͡gken-gguq imna caceskilnguq tua-i arenqiallugpakayuunani.",
        "translation": "They said, however, that a timid person doesn't come to misfortune too much."
    },
    "358": {
        "startTime": 3255.548,
        "endTime": 3262.405,
        "transcript": "Ilumun tua-i tamana wiinga atullruaqa.",
        "translation": "Indeed, I experienced that."
    },
    "359": {
        "startTime": 3262.61,
        "endTime": 3268.667,
        "transcript": "Alingtaama tua-i waniw' arenqiallugpailegma waten ellirtua.",
        "translation": "Because I'm easily scared, I've reached this age before coming to misfortune."
    },
    "360": {
        "startTime": 3268.673,
        "endTime": 3282.902,
        "transcript": "Ataucirquqapiarmek tau͡gaam waten uksumi mat'um maa-i nalliini ugna-llu Alba-llu maavirqaarlunuk utertellmegni",
        "translation": "But only one time in the winter like this recently, when Alba downriver and I went home after coming here"
    },
    "361": {
        "startTime": 3282.926,
        "endTime": 3290.553,
        "transcript": "Qavartarvigmi uaken Kuigilngurmiut canimellekluki qavartaucugyaaqekiinga.",
        "translation": "At Qavartarvik downriver, he wanted to camp with me near Kwigillingok."
    },
    "362": {
        "startTime": 3290.559,
        "endTime": 3296.059,
        "transcript": "Piaqa wii atrarciqnilua, nunat canimetniluki.",
        "translation": "I told him that I'd go down, that the village was close."
    },
    "363": {
        "startTime": 3296.29,
        "endTime": 3307.361,
        "transcript": "Tua-i nunat waniw' tekiteqerluki uunguciircama, au͡gna-llu malika arulairlunuk piaqa",
        "translation": "When I got lost as we reached the lands, my companion and I stopped, and I said to him"
    },
    "364": {
        "startTime": 3307.371,
        "endTime": 3313.371,
        "transcript": "\"Ayagiinarpek'nanuk arulairnaurtukuk, piircian-llu-w' qakemna ella.\"",
        "translation": "\"Let's not continue, but stop, because there's a blizzard out there.\""
    },
    "365": {
        "startTime": 3313.375,
        "endTime": 3319.475,
        "transcript": "Cunaw' wavet nunat keluaraatnun arulaillinilriakuk.",
        "translation": "It turned out that we stopped a short ways inland from the village."
    },
    "366": {
        "startTime": 3319.499,
        "endTime": 3328.214,
        "transcript": "Unuakumi maaten tanqigiaraan qinertua, elitnaurvik una ciuqamegni.",
        "translation": "When I looked out in the mornign as it was getting bright, I found that the school was in front of us."
    },
    "367": {
        "startTime": 3330.598,
        "endTime": 3341.326,
        "transcript": "Au͡gkut ava-i quyanarqut au͡g'um ciuqlirma uum qanrutkurallri. Tua-i amllernek ilasciigatanka.",
        "translation": "I am thankful for what the one before me just said. I can't add too much to them."
    },
    "368": {
        "startTime": 3362.914,
        "endTime": 3368.114,
        "transcript": "Tau͡gaam cali alerquutetangqertuq qanrutkenritellrit makut.",
        "translation": "But there's also an instruction that these didn't speak about."
    },
    "369": {
        "startTime": 3368.374,
        "endTime": 3377.56,
        "transcript": "Alerquutetangqertuq cali: elpenek anangnaqsugngauten, elpenek-llu anagyugngauten tan'gaurlurni.",
        "translation": "There's another instruction: you can try to save yourself, and you boys can save yourselves."
    },
    "370": {
        "startTime": 3377.844,
        "endTime": 3383.744,
        "transcript": "Nani yuilqumi uitang'e'rpet, nenglem nalliini ping'e'rpet",
        "translation": "No matter where you are in the wilderness, even if it's during the cold season"
    },
    "371": {
        "startTime": 3383.765,
        "endTime": 3392.665,
        "transcript": "Elpet teq'urpenek, nakmiin teq'urpenek elpenek urumaarkauguten.",
        "translation": "You must keep yourself warm by your urine, your own urine."
    },
    "372": {
        "startTime": 3392.68,
        "endTime": 3396.065,
        "transcript": "Wiinga call' atulqaqa tamana.",
        "translation": "I've also done that."
    },
    "373": {
        "startTime": 3396.268,
        "endTime": 3404.068,
        "transcript": "Ernerpak, erenrem taktaciatun camek nereksaunii, qaika-llu mecungengan",
        "translation": "All day, since I hadn't eaten for the whole day, and since my body was wet"
    },
    "374": {
        "startTime": 3404.083,
        "endTime": 3411.383,
        "transcript": "Ayainanemni saskamun qurrlua saskangqerrama, egmian mer'aqluku.",
        "translation": "As I went, I would urinate into a cup since I had a cup, and would drink it right away."
    },
    "375": {
        "startTime": 3411.386,
        "endTime": 3417.014,
        "transcript": "Urumaunga kiituan nunamnun tekitua kinguneqa nallunrilamku.",
        "translation": "I kept warm and eventually reached my village, since I knew where my home was."
    },
    "376": {
        "startTime": 3417.019,
        "endTime": 3424.891,
        "transcript": "Erneq waten taklirillran nalliini tau͡gaam nengllirluni unguvallerkamnun tua-i tekillua.",
        "translation": "During the time when the days were long but cold, I made it alive."
    },
    "377": {
        "startTime": 3424.903,
        "endTime": 3435.775,
        "transcript": "Tuamtellu cali arenqiallugingalriamun yuilqumi tekiskuvet cali alerquun, neraunani qerrulluni-llu",
        "translation": "Then another instruction if you reach someone who's come to misfortune in the wilderness, without food and cold"
    },
    "378": {
        "startTime": 3437.068,
        "endTime": 3448.926,
        "transcript": "Cali waniwa ciuqliuluku: teq'urranek wall'u elpet teq'urpenek ikayuyugngaan tauna qerruskii urumallerkaanun.",
        "translation": "This is also the first thing: you can help that cold person with his urine or your urine to warm him up."
    },
    "379": {
        "startTime": 3448.937,
        "endTime": 3453.052,
        "transcript": "Cali-llu arcaqerluku puqlamun pivekanki.",
        "translation": "And most importantly, don't put him in heat."
    },
    "380": {
        "startTime": 3453.26,
        "endTime": 3463.303,
        "transcript": "Puqlamun cali pikuvgu, maa-i nallunrituci, arnani-llu nallunrituci, wangkuta-ll' angutngungramta tanglaraput",
        "translation": "If you put him in heat, you know, and you women know, and we men see it"
    },
    "381": {
        "startTime": 3463.538,
        "endTime": 3469.652,
        "transcript": "Puqlam caniani uitaaqami kumlii ilutmun ayatuuq.",
        "translation": "When he's by a heat source, the cold goes inward."
    },
    "382": {
        "startTime": 3469.665,
        "endTime": 3479.979,
        "transcript": "Elatii tau͡gken man'a urugnganaku, qamna tau͡gken ilua kumla iterluni. Ilutmun nutaan tukniriluni.",
        "translation": "Though his outside looks warm, the cold inside goes in. It gets stronger inward."
    },
    "383": {
        "startTime": 3479.995,
        "endTime": 3482.067,
        "transcript": "Tamatutangqertuq.",
        "translation": "There are those cases."
    },
    "384": {
        "startTime": 3482.204,
        "endTime": 3495.462,
        "transcript": "Makut maa-i ava-i, tua-i-w' ilaitnun neryuniuqsaaqanka qanruteknayukluki au͡gkut ikayuqenqallerkarput.",
        "translation": "These things just now, I was hoping some would talk about them so that we could help someone"
    },
    "385": {
        "startTime": 3495.483,
        "endTime": 3503.655,
        "transcript": "Pitsaqevkenata waten kumlam nangeskiinek tekiskumta tau͡gaam unguvaluni.",
        "translation": "Should happen across someone that the cold is killing, but [still] alive."
    },
    "386": {
        "startTime": 3503.66,
        "endTime": 3512.174,
        "transcript": "Tamaa-i call' ava-i ciuqliuluku neqmek pivailemteggu ciuqliuluku ikayuutekarput.",
        "translation": "That's the first thing before giving him food, the first way we can help."
    },
    "387": {
        "startTime": 3512.193,
        "endTime": 3523.479,
        "transcript": "Apertuumalria cali teq'urput, man'a wangkuta tua-i nakmiin atuqengarput, wangkutnek-llu tua-i ikayuuteksugngaluku cali tuaten pikaumta.",
        "translation": "Our urine that they point out, what we have always done, and we can help ourselves if we are [freezing] like that."
    },
    "388": {
        "startTime": 3523.486,
        "endTime": 3525.086,
        "transcript": "Quyana.",
        "translation": "Thank you."
    }
};